import React from "react";
import HocPlaylist from "../../hoc/HocPlaylist/HocPlaylist";
import "./HeadPlaylist.scss";
import axios from "axios";
import p1 from "../../Photos/songs/castle-of-glass.jpg";
import p2 from "../../Photos/songs/in-the-end.jpg";
import p3 from "../../Photos/songs/what-i've-done.jpg";
import p4 from "../../Photos/songs/one-more-light.jpg";
import p5 from "../../Photos/songs/closer.jpg";
import p6 from "../../Photos/songs/don't-let-me-down.jpg";
import p7 from "../../Photos/songs/call-you-mine.jpg";
import p8 from "../../Photos/songs/the-reason.jpg";
import p9 from "../../Photos/songs/out-of-control.jpg";
import p10 from "../../Photos/songs/same-direction.jpeg";
import p11 from "../../Photos/songs/what-makes-you-beautiful.jpg";
import p12 from "../../Photos/songs/night-changes.png";
import p13 from "../../Photos/songs/best-song-ever.jpg";
import p14 from "../../Photos/songs/highway-to-hell.jpeg";
import p15 from "../../Photos/songs/back-in-black.jpg";
import p16 from "../../Photos/songs/thunderstruck.png";
import p17 from "../../Photos/songs/the-nights.png";
import p18 from "../../Photos/songs/wake-me-up.jpg";
import p19 from "../../Photos/songs/waiting-for-love.png";
import p20 from "../../Photos/songs/ilahi.jpg";
import p21 from "../../Photos/songs/kabira.jpg";
import p22 from "../../Photos/songs/balam-pichkari.jpg";
import p23 from "../../Photos/songs/we-don't-talk-anymore.jpg";
import p24 from "../../Photos/songs/see-you-again.jpg";
import p25 from "../../Photos/songs/one-call-away.jpg";
import p26 from "../../Photos/songs/bheegi-si-bhaagi-si.jpg";
import p27 from "../../Photos/songs/ijazat.jpg";
import p28 from "../../Photos/songs/ek-main-aur-ek-tu.jpg";

function HeadPlaylist({ childToParent, songName, header, src }) {
  function SongCall(id) {
    axios
      .post(`https://music-player-back-production.up.railway.app/songs/${id}`)
      .then((res) => {
        var url = res.data["success"];
        childToParent(url);
      });
  }

  var url = document.URL;
  var lastIndex = url.substring(url.lastIndexOf("/") + 1);
  if (header === lastIndex) {
    return (
      <div className="headplaylist">
        <div className="headplaylist__header">
          <img
            className="headplaylist__header--img"
            src={src}
            alt="album img"
          />
          <h1 className="headplaylist__header--1">{header}</h1>
        </div>
        <div className="headplaylist__songs">
          <HocPlaylist
            header="linkin-park"
            name="Castle of Glass"
            src={p1}
            duration="3:25"
            onClick={(e) => {
              e.preventDefault();
              SongCall("f9b385f8f55d4e71f5c87bca5dd7398c");
              songName("Castle of glass");
            }}
          />
          <HocPlaylist
            header="linkin-park"
            name="In the End"
            src={p2}
            duration="3:38"
            onClick={(e) => {
              e.preventDefault();
              SongCall("96314db77c240acc52079281e773d788");
              songName("In the end");
            }}
          />
          <HocPlaylist
            header="linkin-park"
            name="What I've Done"
            src={p3}
            duration="3:25"
            onClick={(e) => {
              e.preventDefault();
              SongCall("021fe2ed1239b0ac610c79350d9a0153");
              songName("What I've Done");
            }}
          />
          <HocPlaylist
            header="linkin-park"
            name="One more light"
            src={p4}
            duration="4:30"
            onClick={(e) => {
              e.preventDefault();
              SongCall("3baf39c75b2efc0a02535124993752c8");
              songName("One more light");
            }}
          />
          <HocPlaylist
            header="chainsmokers"
            name="Closer"
            src={p5}
            duration="4:21"
            onClick={(e) => {
              e.preventDefault();
              SongCall("1c07ee053ce28b9f39eefeee63acf1b9");
              songName("Closer");
            }}
          />
          <HocPlaylist
            header="chainsmokers"
            name="Don't let me down"
            src={p6}
            duration="3:37"
            onClick={(e) => {
              e.preventDefault();
              SongCall("7ff0a2c1dac39b69e878ec7984d11977");
              songName("Don't let me down");
            }}
          />
          <HocPlaylist
            header="chainsmokers"
            name="Call you mine"
            src={p7}
            duration="3:37"
            onClick={(e) => {
              e.preventDefault();
              SongCall("dac1eff31187a680f2522f59a2a56891");
              songName("Call you mine");
            }}
          />
          <HocPlaylist
            header="hoobastank"
            name="The Reason"
            src={p8}
            duration="4:10"
            onClick={(e) => {
              e.preventDefault();
              SongCall("68a1fa9fc6f2b189008e5673f1974cf7");
              songName("The reason");
            }}
          />
          <HocPlaylist
            header="hoobastank"
            name="Out of Control"
            src={p9}
            duration="2:44"
            onClick={(e) => {
              e.preventDefault();
              SongCall("4fdaa955993905d883d3f6b288163c76");
              songName("Out of control");
            }}
          />
          <HocPlaylist
            header="hoobastank"
            name="Same Direction"
            src={p10}
            duration="3:19"
            onClick={(e) => {
              e.preventDefault();
              SongCall("f1567d96234140801cf282caa5804bb1");
              songName("Same Direction");
            }}
          />
          <HocPlaylist
            header="one-direction"
            name="What makes you Beautiful"
            src={p11}
            duration="3:26"
            onClick={(e) => {
              e.preventDefault();
              SongCall("71c5da86bbff082ba449f24cc007a9e6");
              songName("What makes you Beautiful");
            }}
          />
          <HocPlaylist
            header="one-direction"
            name="Night Changes"
            src={p12}
            duration="4:00"
            onClick={(e) => {
              e.preventDefault();
              SongCall("80ef92a58fdedb17711a8bb3315a532f");
              songName("Night Changes");
            }}
          />
          <HocPlaylist
            header="one-direction"
            name="Best Song Ever"
            src={p13}
            duration="3:18"
            onClick={(e) => {
              e.preventDefault();
              SongCall("59c7c3289ca8c19ffb7e119527336290");
              songName("Best Song Ever");
            }}
          />
          <HocPlaylist
            header="ac-dc"
            name="Highway to Hell"
            src={p14}
            duration="3:27"
            onClick={(e) => {
              e.preventDefault();
              SongCall("7c3d655226638a58e6ccc75f72688143");
              songName("Highway to Hell");
            }}
          />
          <HocPlaylist
            header="ac-dc"
            name="Back in Black"
            src={p15}
            duration="4:13"
            onClick={(e) => {
              e.preventDefault();
              SongCall("b802798e38c9afe0eccee62a3c79e914");
              songName("Back in Black");
            }}
          />
          <HocPlaylist
            header="ac-dc"
            name="Thunderstruck"
            src={p16}
            duration="4:53"
            onClick={(e) => {
              e.preventDefault();
              SongCall("aeeff70bd592a87d6c32061a754cb1dc");
              songName("Thunderstruck");
            }}
          />
          <HocPlaylist
            header="avicii"
            name="The Nights"
            src={p17}
            duration="3:10"
            onClick={(e) => {
              e.preventDefault();
              SongCall("a7a50797ea25543fc867a1675fa85116");
              songName("The Nights");
            }}
          />
          <HocPlaylist
            header="avicii"
            name="Wake Me Up"
            src={p18}
            duration="4:32"
            onClick={(e) => {
              e.preventDefault();
              SongCall("f1607aceab1bf909ae8ec6d92e055f6f");
              songName("Wake me up");
            }}
          />
          <HocPlaylist
            header="avicii"
            name="Waiting for Love"
            src={p19}
            duration="3:50"
            onClick={(e) => {
              e.preventDefault();
              SongCall("393bfe187ffae1e65bebbcdafb94ec1e");
              songName("");
            }}
          />
          <HocPlaylist
            header="ye-jawani-hai-deewani"
            name="Ilahi"
            src={p20}
            duration="3:23"
            onClick={(e) => {
              e.preventDefault();
              SongCall("61d65ea52fa8149b829acadf232b6694");
              songName("Ilahi");
            }}
          />
          <HocPlaylist
            header="ye-jawani-hai-deewani"
            name="Kabira"
            src={p21}
            duration="4:11"
            onClick={(e) => {
              e.preventDefault();
              SongCall("e17e5bc210e53898155e49da29c480a6");
              songName("Kabira");
            }}
          />
          <HocPlaylist
            header="ye-jawani-hai-deewani"
            name="Balam Pichkari"
            src={p22}
            duration="4:19"
            onClick={(e) => {
              e.preventDefault();
              SongCall("f672bb170c8b6cdd702c6e2252d6cff7");
              songName("Balam Pichkari");
            }}
          />
          <HocPlaylist
            header="charlie-puth"
            name="We don't talk anymore"
            src={p23}
            duration="3:50"
            onClick={(e) => {
              e.preventDefault();
              SongCall("40a074a6ae84d38326297747c142ffe2");
              songName("We don't talk anymore");
            }}
          />
          <HocPlaylist
            header="charlie-puth"
            name="See You Again"
            src={p24}
            duration="3:57"
            onClick={(e) => {
              e.preventDefault();
              SongCall("b0039be99dd884f9f7fec9c8124ae3ae");
              songName("See you again");
            }}
          />
          <HocPlaylist
            header="charlie-puth"
            name="One Call Away"
            src={p25}
            duration="4:01"
            onClick={(e) => {
              e.preventDefault();
              SongCall("8af4773cffeae963b965f6768b94bc8e");
              songName("One call away");
            }}
          />
          <HocPlaylist
            header="bollywood-songs"
            name="Bheegi si Bhaagi si"
            src={p26}
            duration="4:17"
            onClick={(e) => {
              e.preventDefault();
              SongCall("390caeea05abbe714dceef44fcb90f31");
              songName("Bheegi si bhaagi si");
            }}
          />
          <HocPlaylist
            header="bollywood-songs"
            name="Ijazat"
            src={p27}
            duration="4:41"
            onClick={(e) => {
              e.preventDefault();
              SongCall("d952cb820f8ab07496deff25f5560e1d");
              songName("Ijazat");
            }}
          />
          <HocPlaylist
            header="bollywood-songs"
            name="Ek main aur Ekk tu"
            src={p28}
            duration="4:38"
            onClick={(e) => {
              e.preventDefault();
              SongCall("8b4eb1feedefe8ee092417bc59b47fa2");
              songName("Ek main aur ekk tu");
            }}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default HeadPlaylist;
